import { T, useLang } from "@/lib/i18n";
import { AI_MATRIX, BENEFITS, METHOD_INTRO, STAKEHOLDER_NOTE } from "@/data/portfolio";
import Benefit from "@/components/site/Benefit";

export default function AIMethodology() {
  const { t } = useLang();
  return (
    <section
      id="ai-methodology"
      data-testid="ai-methodology-section"
      className="border-t border-[#e5e0d8] section-pad bg-[#faf8f5]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div className="max-w-3xl">
            <div className="font-mono-label text-[11px] text-[#9a7218]">
              {t("06 · Methodology")}
            </div>
          </div>
          <p className="text-sm text-[#55625b] max-w-sm leading-relaxed">
            {t(METHOD_INTRO)}
          </p>
        </div>

        <div className="mt-8 border-t border-[#d4cebe]">
          <div className="hidden lg:grid grid-cols-12 gap-6 py-2.5 border-b border-[#d4cebe] font-mono-label text-[9px] text-[#86928a]">
            <div className="col-span-4">{t("Stage")}</div>
            <div className="col-span-8">{t("What I do, and where AI helps")}</div>
          </div>
          {AI_MATRIX.map((row, i) => (
            <div
              key={i}
              data-testid={`ai-matrix-row-${i}`}
              className="grid grid-cols-1 lg:grid-cols-12 gap-2 lg:gap-6 py-4 border-b border-[#d4cebe] hover:bg-white transition-colors"
            >
              <div className="lg:col-span-4 flex items-baseline gap-3">
                <span className="font-mono-label text-[9px] text-[#9a7218]">
                  0{i + 1}
                </span>
                <span className="font-display text-lg text-[#14352a]">
                  {t(row.stage)}
                </span>
              </div>
              <div className="lg:col-span-8 text-sm text-[#14352a] leading-relaxed">
                {t(row.ai)}
              </div>
            </div>
          ))}
        </div>

        <div data-testid="stakeholder-note" className="mt-6 p-6 sm:p-7 bg-[#14352a] text-[#faf8f5] border-l-4 border-[#d9a92e] grid lg:grid-cols-12 gap-4">
          <div className="lg:col-span-4 font-mono-label text-[9px] text-[#d9a92e]">{t(STAKEHOLDER_NOTE.title)}</div>
          <p className="lg:col-span-8 text-base leading-relaxed text-[#faf8f5]/85">{t(STAKEHOLDER_NOTE.body)}</p>
        </div>

        <Benefit text={BENEFITS.ai} testid="benefit-ai" />
      </div>
    </section>
  );
}
